import { useCallback } from "react";
import { useOverlays } from "../../../contexts/OverlayContext";
import { ReportSettingsEditorDrawer } from "./ReportSettingsEditorDrawer";

export const ReportSettingsEditorDrawerContainer = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("reportSettingsEditor");
    const data = overlayInfo?.data;

    const handleClose = useCallback(() => {
        const restoreSettings = data?.restoreSettings;
        closeOverlay();
        restoreSettings?.();
    }, [closeOverlay, data]);

    if (!data) {
        return null;
    }

    return (
        <ReportSettingsEditorDrawer
            open={!overlayIsClosing}
            subject={data}
            onClose={handleClose}
        />
    );
};
